<p-drawer 
    header="Wallet" 
    (onHide)="onClose.emit()" 
    [visible]="isDialogVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <spike-account-transfer-form [form]="form"></spike-account-transfer-form>
    <ng-template #footer>
        <div class="flex gap-4 w-full justify-between">

            <div class="w-full">
                <p-button (click)="onSaveClicked()" [disabled]="form.invalid" icon="pi pi-save" label="Salva" severity="primary" styleClass="w-full"></p-button>
            </div>
        </div>
    </ng-template>
</p-drawer>
